var ko = require('knockout');

// A binding that allows usage of jQuery UI's datepicker utility
//
// example:
//
// var SubscriptionData = {
//  start_date: ko.observable(new Date()),
//  end_date: ko.observable(new Date())
// };
//
// ko.applyBindings(SubscriptionData, $('#subscription-data')[0]);

module.exports = {
  init: function(el, valueAccessor, allBindings, data, context) {
    $(el).datepicker(valueAccessor());
  }
};
